module.exports = __webpack_public_path__ + "static/media/theme.57326760.png";